import React, { FC } from 'react'
import { Typography, DialogActions, Button, Box } from '@mui/material'
import { StatefulDialog } from 'src/components/ui'
import { DialogNames } from 'src/enums'

interface ConfirmOwnerRoleDowngradeModalProps {
  roleName: string
  contractorName: string
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmOwnerRoleDowngradeModal: FC<ConfirmOwnerRoleDowngradeModalProps> = ({
  roleName,
  contractorName,
  onConfirm,
  onCancel,
}) => {
  return (
    <StatefulDialog
      name={DialogNames.ConfirmOwnerRoleDowngrade}
      actions={
        <Box mb={2} mx={2}>
          <DialogActions>
            <Button variant="outlined" onClick={onCancel}>
              No
            </Button>
            <Button variant="contained" color="primary" onClick={onConfirm}>
              Yes
            </Button>
          </DialogActions>
        </Box>
      }
    >
      <Box minWidth="300px">
        <Typography variant="h6">
          This user is {roleName} of the {contractorName} contractor. Their current role will be downgraded to the view-only. Do you want to proceed?
        </Typography>
      </Box>
    </StatefulDialog>
  )
}
